var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.income_group.uid))]),(_vm.income_group.del)?_c('div',{staticClass:"color-error"},[_vm._v("[已废弃]")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }